import { useEffect, useState } from "react";
import "./Footer.css";

const destinations = ["Kampala", "Uvira", "Bukavu", "Kalemi", "Lubumbashi", "Moba"];

const services = [
  "Expedition de colis",
  "Transport de marchandises",
  "Reception en agence",
  "Suivi client",
];

const defaultContacts = {
  tel: "",
  tel1: "",
  tel2: "",
  email: "",
};

const whatsappNumber = "243895817994";
const defaultWhatsappMessage = "https://lavictoire-express.com\n\n\nBonjour La Victoire Express, je souhaite avoir des informations pour expedier un colis.";

export const Footer = () => {
  const [branches, setBranches] = useState([]);
  const [message, setMessage] = useState(defaultWhatsappMessage);

  useEffect(() => {
    async function fetchBranches() {
      try {
        let response = await fetch(process.env.REACT_APP_API_EVIVEMANIFESTE + "/branches");
        response = await response.json();
        setBranches(Array.isArray(response) ? response : []);
      } catch (error) {
        setBranches([]);
      }
    }

    fetchBranches();
  }, []);

  const mainBranch = branches[0] || defaultContacts;
  const phoneNumbers = [mainBranch.tel, mainBranch.tel1, mainBranch.tel2].filter(Boolean);
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message || defaultWhatsappMessage)}`;

  function handleWhatsappSubmit(event) {
    event.preventDefault();
    window.open(whatsappUrl, "_blank", "noopener,noreferrer");
  }

  return (
    <footer className="site-footer">
      <div className="site-footer__top">
        <div className="container site-footer__top-inner">
          <div>
            <span className="site-footer__label">La Victoire Express</span>
            <h2>Vos colis entre Kampala et le Congo, avec un service clair et organise.</h2>
          </div>
          <form className="site-footer__whatsapp" onSubmit={handleWhatsappSubmit}>
            {/* <input
              type="text"
              value={message}
              onChange={(event) => setMessage(event.target.value)}
              placeholder="Votre message WhatsApp"
            /> */}
            <button type="submit">
              Contacter l'agence <i className="fa fa-whatsapp"></i>
            </button>
          </form>
        </div>
      </div>

      <div className="site-footer__main">
        <div className="container">
          <div className="site-footer__grid">
            <div className="site-footer__brand">
              <div className="site-footer__logo">
                <img src="/img/logo.png" alt="La Victoire Express" />
              </div>
              <p>
                Agence d'expedition de colis et marchandises pour les particuliers,
                commercants et entreprises entre Kampala, Uvira, Bukavu, Kalemi,
                Lubumbashi, Moba et les axes voisins.
              </p>
              <div className="site-footer__socials">
                <a href="#" aria-label="Facebook"><i className="fa fa-facebook"></i></a>
                <a href="#" aria-label="YouTube"><i className="fa fa-youtube-play"></i></a>
                <a href="#" aria-label="Twitter"><i className="fa fa-twitter"></i></a>
                <a href="#" aria-label="Instagram"><i className="fa fa-instagram"></i></a>
              </div>
            </div>

            <div>
              <h3>Destinations</h3>
              <div className="site-footer__chips">
                {destinations.map((destination) => (
                  <span key={destination}><i className="fa fa-map-marker"></i>{destination}</span>
                ))}
              </div>
            </div>

            <div>
              <h3>Services</h3>
              <ul className="site-footer__links">
                {services.map((service) => (
                  <li key={service}><i className="fa fa-check"></i>{service}</li>
                ))}
              </ul>
            </div>

            <div>
              <h3>Contact</h3>
              <div className="site-footer__contact">
                <a href={whatsappUrl} target="_blank" rel="noreferrer"><i className="fa fa-whatsapp"></i>+243 895 817 994</a>

                {phoneNumbers.length > 0 ? (
                  phoneNumbers.map((phone) => (
                    <a href={"tel:" + phone} key={phone}><i className="fa fa-phone"></i>{phone}</a>
                  ))
                ) : (
                  <span><i className="fa fa-phone"></i>Telephone disponible en agence</span>
                )}

                {mainBranch.email ? (
                  <a href={"mailto:" + mainBranch.email}><i className="fa fa-envelope"></i>{mainBranch.email}</a>
                ) : (
                  <span><i className="fa fa-envelope"></i>Email disponible en agence</span>
                )}
              </div>
            </div>
          </div>

          {branches.length > 0 && (
            <div className="site-footer__branches">
              <div className="site-footer__branches-head">
                <span>Nos agences et points de contact</span>
                <strong>{branches.length} point{branches.length > 1 ? "s" : ""} disponible{branches.length > 1 ? "s" : ""}</strong>
              </div>
              <div className="site-footer__branches-grid">
                {branches.slice(0, 6).map((branch) => (
                  <div className="site-footer__branch" key={branch.id || branch.tel || branch.email}>
                    <strong>{branch.city} {branch.region}</strong>
                    <span>{branch.municipality} {branch.neighborhood}</span>
                    <div>
                      {branch.tel && <a href={"tel:" + branch.tel}>{branch.tel}</a>}
                      {branch.email && <a href={"mailto:" + branch.email}>{branch.email}</a>}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="site-footer__bottom">
        <div className="container site-footer__bottom-inner">
          <span>© {new Date().getFullYear()} La Victoire Express. Tous droits reserves.</span>
          <a href="http://evivedigital.net">EviveDigital</a>
        </div>
      </div>
    </footer>
  );
};
